import { render, staticRenderFns } from "./TicketIDColumn.vue?vue&type=template&id=46946009&"
import script from "./TicketIDColumn.vue?vue&type=script&lang=js&"
export * from "./TicketIDColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports